import React from "react";

import NanoFlex from '../Global/NanoFlex.js';
import InputWheel from './InputWheel.js';

const lastMinuteList = ['59'];
const halfHourList = ['00', '30'];
const hourList = new Array(24).fill(0).map( (v, i) => {
    if (i < 10) {
        return '0' + (v + i);
    } else {
        return (v + i).toString();
    };
});

const mock = {
   start: { hour: 10, minutes: 0 },
   end: { hour: 12, minutes: 59 }
};

class TimeInputWheel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startHourSelectedIndex: this.props.selectedRange ? this.updateSelectedRange(this.props.selectedRange).startHourSelectedIndex : 0,
            startMinutesSelectedIndex: this.props.selectedRange ? this.updateSelectedRange(this.props.selectedRange).startMinutesSelectedIndex : 0,
            endHourSelectedIndex: this.props.selectedRange ? this.updateSelectedRange(this.props.selectedRange).endHourSelectedIndex : 0
        };
    }

    componentDidMount() {
        this.props.onChangeInput( this.outputResult() );
        if (this.props.selectedRange) this.updateSelectedRange(this.props.selectedRange);
    }

    componentDidUpdate(prevProps, prevState) {
        if ((prevState.startHourSelectedIndex !== this.state.startHourSelectedIndex
            && this.state.startHourSelectedIndex <= this.state.endHourSelectedIndex)
            || prevState.startMinutesSelectedIndex !== this.state.startMinutesSelectedIndex
            || prevState.endHourSelectedIndex !== this.state.endHourSelectedIndex) {
                this.props.onChangeInput( this.outputResult() );
        };

        if (prevState.startHourSelectedIndex !== this.state.startHourSelectedIndex
            && this.state.startHourSelectedIndex > this.state.endHourSelectedIndex) {
                this.setState({
                    endHourSelectedIndex: this.state.startHourSelectedIndex
                });
        };

        if (prevState.endHourSelectedIndex !== this.state.endHourSelectedIndex
            && this.state.startHourSelectedIndex > this.state.endHourSelectedIndex) {
                this.setState({
                    startHourSelectedIndex: this.state.endHourSelectedIndex
                });
        };
    }

    updateSelectedRange = (obj) => {
        const addZero = (n) => {
            if (n < 10) {
                return '0' + n;
            } else {
                return n.toString();
            };
        };

        const indexFinder = (input, list) => {
            const output = list.indexOf(addZero(input));
            return output === '-1' ? 0 : output;
        };

        return {
            startHourSelectedIndex: indexFinder(obj.start.hour, hourList),
            startMinutesSelectedIndex: indexFinder(obj.start.minutes, halfHourList),
            endHourSelectedIndex: indexFinder(obj.end.hour, hourList),
        };
    }

    updateDateIndex = (type, index, list) => {
        if (type === 'startHour') {
            this.setState({
                startHourSelectedIndex: index
            });
        };

        if (type === 'startMinutes') {
            this.setState({
                startMinutesSelectedIndex: index
            });
        };

        if (type === 'endHour') {
            this.setState({
                endHourSelectedIndex: index
            });
        };
    }

    outputResult = () => {
        const mainOutput = {
            start: [hourList[this.state.startHourSelectedIndex], halfHourList[this.state.startMinutesSelectedIndex]],
            end: [hourList[this.state.endHourSelectedIndex], lastMinuteList[0]]
        };

        const outputText = `Start: ${mainOutput.start[0]}:${mainOutput.start[1]} | End: ${mainOutput.end[0]}:${mainOutput.end[1]}`;

        const output = {
            start: { hour: mainOutput.start[0], minutes: mainOutput.start[1] },
            end: { hour: mainOutput.end[0], minutes: 59 },
            text: outputText
        };

        return output;
    }

    render() {
        return (
            <NanoFlex width='200px'>
                <NanoFlex>
                    <InputWheel
                        data={hourList}
                        type='startHour'
                        selected={this.state.startHourSelectedIndex}
                        onDateChange={(type, index, list) => this.updateDateIndex(type, index, list)}
                    />
                    <InputWheel
                        data={halfHourList}
                        type='startMinutes'
                        selected={this.state.startMinutesSelectedIndex}
                        onDateChange={(type, index, list) => this.updateDateIndex(type, index, list)}
                    />
                </NanoFlex>
                <NanoFlex>
                    <InputWheel
                        data={hourList}
                        type='endHour'
                        selected={this.state.endHourSelectedIndex}
                        onDateChange={(type, index, list) => this.updateDateIndex(type, index, list)}
                    />
                    <InputWheel
                        data={lastMinuteList}
                        type='endMinutes'
                        selected={0}
                        onDateChange={(type, index, list) => this.updateDateIndex(type, index, list)}
                    />
                </NanoFlex>
            </NanoFlex>
        );
    }
};

export default TimeInputWheel;

// Set default props
TimeInputWheel.defaultProps = {
    selectedRange: mock
};

// --- // Documentation // --- //
/*
import TimeInputWheel from './../Nano/TimeInputWheel.js';

<TimeInputWheel
    selectedRange={mock}
    onChangeInput={(obj) => console.log('TimeInputWheel => onChangeInput', obj)}
/>
*/
